export interface PitchSlide {
  id: number;
  slug: string;
  category: string;
  title: string;
  subtitle: string;
}

export interface IndustryPricing {
  id: string;
  name: string;
  badge: string;
  color: string;
  setupInr: string;
  monthlyInr: string;
  setupUsd: string;
  monthlyUsd: string;
  targetCloseInr: string;
  targetCloseUsd: string;
  walkawayInr: string;
  walkawayUsd: string;
  keyAssets: string[];
  demoUrl: string;
  crmUrl: string;
}

export const PITCH_PRICING_DATA: IndustryPricing[] = [
  {
    id: "real-estate",
    name: "Luxury Real Estate & High-Value Brokers",
    badge: "High Ticket",
    color: "amber",
    setupInr: "₹1,50,000",
    monthlyInr: "₹35,000 /mo",
    setupUsd: "$2,200",
    monthlyUsd: "$490 /mo",
    targetCloseInr: "₹1,15,000 + ₹28,000/mo",
    targetCloseUsd: "$1,650 + $390/mo",
    walkawayInr: "₹85,000 + ₹22,000/mo",
    walkawayUsd: "$1,200 + $290/mo",
    keyAssets: [
      "VIP Chauffeur & Site Visit Itinerary PDF",
      "Official Token Advance Deposit Receipt PDF",
      "Meta WhatsApp Instant Site Visit Pass",
    ],
    demoUrl: "/demos/real-estate",
    crmUrl: "/demos/real-estate/crm",
  },
  {
    id: "restaurant",
    name: "Fine Dining & Boutique Hospitality",
    badge: "High Volume",
    color: "rose",
    setupInr: "₹75,000",
    monthlyInr: "₹18,000 /mo",
    setupUsd: "$1,100",
    monthlyUsd: "$260 /mo",
    targetCloseInr: "₹55,000 + ₹14,000/mo",
    targetCloseUsd: "$800 + $200/mo",
    walkawayInr: "₹42,000 + ₹11,000/mo",
    walkawayUsd: "$600 + $160/mo",
    keyAssets: [
      "Chef Tasting Menu & Table Reservation Pass",
      "Banquet & Private Dining Tax Invoice PDF",
      "WhatsApp Table Confirmation in <2s",
    ],
    demoUrl: "/demos/restaurant",
    crmUrl: "/demos/restaurant/crm",
  },
  {
    id: "gym",
    name: "Luxury Fitness & Athletic Clubs",
    badge: "Recurring Dues",
    color: "emerald",
    setupInr: "₹85,000",
    monthlyInr: "₹20,000 /mo",
    setupUsd: "$1,250",
    monthlyUsd: "$290 /mo",
    targetCloseInr: "₹65,000 + ₹16,000/mo",
    targetCloseUsd: "$950 + $230/mo",
    walkawayInr: "₹48,000 + ₹12,500/mo",
    walkawayUsd: "$700 + $180/mo",
    keyAssets: [
      "VIP Day Pass with Dynamic QR Code PDF",
      "Annual Athletic Dues Tax Invoice PDF",
      "WhatsApp Locker & Orientation Passes",
    ],
    demoUrl: "/demos/gym",
    crmUrl: "/demos/gym/crm",
  },
  {
    id: "dental",
    name: "Dental Clinics & Aesthetic Institutes",
    badge: "Clinical High Ticket",
    color: "cyan",
    setupInr: "₹1,10,000",
    monthlyInr: "₹25,000 /mo",
    setupUsd: "$1,600",
    monthlyUsd: "$360 /mo",
    targetCloseInr: "₹85,000 + ₹20,000/mo",
    targetCloseUsd: "$1,250 + $290/mo",
    walkawayInr: "₹65,000 + ₹15,000/mo",
    walkawayUsd: "$950 + $220/mo",
    keyAssets: [
      "iTero 3D Scan & Clinical Consultation Pass",
      "3-Year E.max Warranty & Implant Tax Invoice PDF",
      "WhatsApp Post-Procedure Clinical Instructions",
    ],
    demoUrl: "/demos/dental",
    crmUrl: "/demos/dental/crm",
  },
  {
    id: "insurance",
    name: "Insurance Brokers & Wealth Underwriters",
    badge: "Regulatory / Compliance",
    color: "blue",
    setupInr: "₹1,35,000",
    monthlyInr: "₹30,000 /mo",
    setupUsd: "$1,950",
    monthlyUsd: "$440 /mo",
    targetCloseInr: "₹1,05,000 + ₹24,000/mo",
    targetCloseUsd: "$1,500 + $350/mo",
    walkawayInr: "₹78,000 + ₹18,500/mo",
    walkawayUsd: "$1,100 + $270/mo",
    keyAssets: [
      "Diagnostic Medical Exam & Checklist PDF",
      "Official Policy Schedule & Underwriting Certificate",
      "WhatsApp Premium Due & Policy Delivery",
    ],
    demoUrl: "/demos/insurance",
    crmUrl: "/demos/insurance/crm",
  },
  {
    id: "telecalling",
    name: "Telecalling Agencies & BPO Centers",
    badge: "Seat Retainers",
    color: "indigo",
    setupInr: "₹1,40,000",
    monthlyInr: "₹35,000 /mo",
    setupUsd: "$2,000",
    monthlyUsd: "$500 /mo",
    targetCloseInr: "₹1,10,000 + ₹28,000/mo",
    targetCloseUsd: "$1,550 + $400/mo",
    walkawayInr: "₹80,000 + ₹21,000/mo",
    walkawayUsd: "$1,150 + $300/mo",
    keyAssets: [
      "Discovery Demo Itinerary Briefing PDF",
      "Master Services Agreement & Retainer Invoice PDF",
      "WhatsApp Call Disposition & Callback Alerts",
    ],
    demoUrl: "/demos/telecalling",
    crmUrl: "/demos/telecalling/crm",
  },
  {
    id: "hiring",
    name: "Staffing & Executive Recruitment Agencies",
    badge: "Retained Search",
    color: "purple",
    setupInr: "₹1,60,000",
    monthlyInr: "₹40,000 /mo",
    setupUsd: "$2,300",
    monthlyUsd: "$570 /mo",
    targetCloseInr: "₹1,25,000 + ₹32,000/mo",
    targetCloseUsd: "$1,800 + $450/mo",
    walkawayInr: "₹95,000 + ₹24,000/mo",
    walkawayUsd: "$1,350 + $340/mo",
    keyAssets: [
      "Candidate Evaluation Dossier & Briefing Pass PDF",
      "Executive Placement Engagement Invoice PDF",
      "WhatsApp Interview Scheduling & Candidate Alerts",
    ],
    demoUrl: "/demos/hiring",
    crmUrl: "/demos/hiring/crm",
  },
];

export const NEGOTIATION_RULES = [
  {
    rule: "Rule 1: Never Discount Without Getting a Concession",
    desc: "If the client asks for 15% off, grant it ONLY if they pay the entire year upfront. This secures guaranteed cashflow with zero churn risk.",
    benefit: "Guarantees 12 months ARR upfront",
  },
  {
    rule: "Rule 2: Exchange Reductions for Co-Marketing & Logo Rights",
    desc: "Offer ₹15,000 / $200 off setup in exchange for a written case study, Google review, and permission to showcase their metrics.",
    benefit: "Fuels high-converting social proof for future sales",
  },
  {
    rule: "Rule 3: Enforce a Strict 48-Hour Pilot Expiration",
    desc: "State that the discounted onboarding rate is reserved for current month server allocations and expires in 48 hours to compel immediate sign-off.",
    benefit: "Eliminates prolonged decision lag and closes deals on the call",
  },
];
